// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2610) return "static/chunks/2610.6b4cae123d37a40d.js";
	if (chunkId === 6472) return "static/chunks/6472.6f0f5b9ad35b91eb.js";
	if (chunkId === 2672) return "static/chunks/2672.f504480ab4ffe4e5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"844":"ee560e2c","2202":"eec3d76d","6711":"8e1d74a4","8087":"0e762574"}[chunkId] || chunkId) + "-" + {"844":"bebbefdce31b8e20","2202":"78e7d0b7085c6df9","2651":"105e81c374a1d1a8","5565":"8dbf51f1c6c24e53","6711":"bf64a63f17d8f4f1","8087":"bbf578f9466c52cc","8173":"4ee3bc31cddff1d6"}[chunkId] + ".js";
};